
    <h2 mat-dialog-title>Report Incident</h2>
    <mat-dialog-content>
      <p>This will reset the <strong>{{ data.incident_type === 'osha' ? 'OSHA Recordable' : 'Vehicle Accident' }}</strong> counter to 0.</p>
      <mat-form-field style="width: 100%">
        <mat-label>Reason for reset</mat-label>
        <textarea matInput [(ngModel)]="reason" rows="3" placeholder="Describe the incident..."></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-raised-button color="warn" [disabled]="!reason || !reason.trim()" (click)="dialogRef.close(reason)">Reset Counter</button>
    </mat-dialog-actions>
  